import React, { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core'
import { Edit } from '@material-ui/icons'
import { AuthService, SalesService } from 'lib/api'

export default function ChangeUserModal({ saleId, deal, handleChangeManager }) {
  const [openEditor, setOpenEditor] = useState(false)
  const [user, setUser] = useState('')
  const [userList, setUserList] = useState([])
  const { enqueueSnackbar } = useSnackbar()
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleToggleEditor = () => {
    setOpenEditor(!openEditor)
  }
  const [changeAllWorksheets, setChangeAllWorksheets] = useState(false)
  const [warningModal, setWarningModal] = useState(false)

  const [assignUser, setAssignUser] = useState([])

  const handleChangeSelect = e => {
    const value = e.target.value
    setUser(value)
  }

  const getManagers = async () => {
    try {
      const requestData = {
        isActive: true,
        limit: 300,
        offset: 0,
        projectCode: 'CS_V2',
        roleCode: 'MANAGER',
        branchCode: deal.branch?.code
      }

      const res = await AuthService.getUsers(requestData)
      setUserList(res.data.userList)
    } catch (error) {
      setLoading(false)
      setError(error.message)
    }
  }

  const handleUpdateClient = async () => {
    const selectedUser = userList.find(item => item.id === user)
    const data = {
      id: saleId,
      assignTo: selectedUser?.username,
      assignToFullName: selectedUser
        ? [selectedUser?.lastName, selectedUser?.firstName].join(' ')
        : '', // lastName + firstName
      headManagerUsername: selectedUser?.headManagerUser?.username,
      headManagerFullname: selectedUser?.headManagerUser
        ? [
            selectedUser?.headManagerUser?.lastName,
            selectedUser?.headManagerUser?.firstName
          ].join(' ')
        : '',
      ropUsername: selectedUser?.headManagerUser?.ropUser?.username,
      ropFullname: selectedUser?.headManagerUser?.ropUser
        ? [
            selectedUser?.headManagerUser?.ropUser?.lastName,
            selectedUser?.headManagerUser?.ropUser?.firstName
          ].join(' ')
        : '',
      setAssignToForAllActiveSales: changeAllWorksheets ? true : false
    }

    try {
      setLoading(true)
      await SalesService.updateSale(data)
      setLoading(false)
      enqueueSnackbar('Менеджер успешно изменен!', {
        variant: 'success'
      })
    } catch (error) {
      setLoading(false)
    }
    if (!!handleChangeManager) {
      handleChangeManager(data.assignToFullName)
    }

    setOpenEditor(!openEditor)
    setWarningModal(!warningModal)
  }

  const handleCheckRop = event => {
    setChangeAllWorksheets(event.target.checked)
  }

  const handleOpenWarningModal = () => {
    if (!changeAllWorksheets) {
      handleUpdateClient()
    }
    setWarningModal(true)
  }

  const handleToggleModal = () => {
    setWarningModal(!warningModal)
  }

  const getAssignManager = async () => {
    try {
      const res = await AuthService.getUsers({
        limit: 100,
        offset: 0,
        projectCode: 'CS_V2',
        username: deal.assignTo
      })
      setAssignUser(res.data.userList)
    } catch (e) {
      setLoading(false)
      setError(error.message)
    }
  }

  useEffect(() => {
    if (openEditor) {
      getManagers()
      getAssignManager()
    }
  }, [openEditor])

  const isActiveValues = assignUser.map(user => user.isActive)

  return (
    <>
      <IconButton color="primary" size={'small'} onClick={handleToggleEditor}>
        <Edit fontSize="inherit" />
      </IconButton>

      <Dialog open={openEditor} maxWidth="md" onClose={handleToggleEditor}>
        <DialogTitle>Изменить менеджера</DialogTitle>

        <DialogContent>
          <Grid item md={12} sm={12} xs={12}>
            <TextField
              name={'signatory'}
              value={user}
              label={'Менеджер'}
              onChange={handleChangeSelect}
              fullWidth
              select
            >
              <MenuItem value="">
                <em>{'Нет выбрано'}</em>
              </MenuItem>

              {userList.length > 0 &&
                userList.map(item => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.lastName + ' ' + item.firstName}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>

          {isActiveValues?.length > 0 && !isActiveValues[0] && (
            <FormControlLabel
              label="Изменить все другие рабочие листы"
              control={
                <Checkbox
                  checked={changeAllWorksheets}
                  onChange={handleCheckRop}
                  name="ropCheck"
                />
              }
            />
          )}

          <Box my={2} display="flex" justifyContent="center">
            <Box mx={1}>
              <Button
                disabled={loading}
                variant="contained"
                onClick={handleToggleEditor}
              >
                Отмена
              </Button>
            </Box>

            <Box mx={1}>
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                onClick={handleOpenWarningModal}
              >
                Изменить
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {warningModal && changeAllWorksheets && (
        <Dialog
          open={handleOpenWarningModal}
          maxWidth="sm"
          onClose={handleToggleModal}
        >
          <DialogTitle>Завершение работы</DialogTitle>
          <DialogContent>
            <Box mx={1} display="flex" justifyContent="center">
              <Typography variant="body1" style={{ maxWidth: '300px' }}>
                Вы уверены, что хотите изменить все активные рабочие листы? Этот
                процесс необратим!
              </Typography>
            </Box>
          </DialogContent>
          <DialogContent>
            <Box my={2} display="flex" justifyContent="center">
              <Box mx={1}>
                <Button
                  disabled={loading}
                  variant="contained"
                  onClick={handleToggleModal}
                >
                  Отмена
                </Button>
              </Box>
              <Box mx={1}>
                <Button
                  disabled={loading}
                  variant="contained"
                  color="primary"
                  onClick={handleUpdateClient}
                >
                  Да
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}
